import '../assets/button-icon.css';
import { jsx as i } from "react/jsx-runtime";
import c from "clsx";
import { useContext as a } from "react";
import { ButtonContext as e } from "../context.js";
const m = "_button_icon_6f2io_1", u = {
  button_icon: m
}, b = (t) => {
  const { className: o, ...n } = t, { size: s, variant: r } = a(e);
  return /* @__PURE__ */ i("div", { className: c(u.button_icon, o), "data-variant": r, "data-size": s, ...n });
};
export {
  b as ButtonIcon
};
